<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <p class="academics-text">{{ content.page }}</p>
  </v-container>
</template>

<script>
export default {
  name: 'IndustryCalls',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
